import { decompressFromEncodedURIComponent } from 'lz-string'

import { useTaxonomy } from '@/stores/taxonomy'
import { maLogger } from '@/base/logger'
import { SAFE_VALUES } from '@/base/constants/SafeValues'
import { Query } from '@/base/constants/route'

export async function maTaxonomyGuard(to, _, next) {
  const taxonomyStore = useTaxonomy()

  const activeFilterKeys = [to.query[Query.CATEGORY_ID], to.query[Query.APP_TAXONOMIES], to.query[Query.GAME_TAXONOMIES]].filter(Boolean)

  if (!activeFilterKeys.length) {
    to.query[Query.CATEGORY_ID] = SAFE_VALUES.categoryId
    return next(to)
  }

  // ignore multiple filters
  if (activeFilterKeys.length > 1) {
    const firstActiveFilterKey = activeFilterKeys[0]
    Object.keys(to.query).forEach((key) => {
      if ([Query.CATEGORY_ID, Query.APP_TAXONOMIES, Query.GAME_TAXONOMIES].includes(key) && to.query[key] !== firstActiveFilterKey) {
        delete to.query[key]
      }
    })
    return next(to)
  }

  try {
    await taxonomyStore.fetchTaxonomies()
  }
  catch (error) {
    maLogger.warn('Failed to fetch taxonomies', error)

    if (!to.query[Query.CATEGORY_ID]) {
      to.query[Query.CATEGORY_ID] = SAFE_VALUES.categoryId
    }

    return next(to)
  }

  if (to.query[Query.APP_TAXONOMIES] || to.query[Query.GAME_TAXONOMIES]) {
    const activeQueryKey = to.query[Query.APP_TAXONOMIES] ? Query.APP_TAXONOMIES : Query.GAME_TAXONOMIES
    try {
      const taxonomyIds = JSON.parse(decompressFromEncodedURIComponent(to.query[activeQueryKey]))
      const isValidIds = taxonomyIds.every(taxonomyId => !!taxonomyStore.idBasedTaxonomies?.[taxonomyId])
      if (!isValidIds) {
        throw new Error('Invalid taxonomy id')
      }
    }
    catch (e) {
      maLogger.error('Invalid taxonomy query parameter', e)
      delete to.query[activeQueryKey]
      to.query[Query.CATEGORY_ID] = SAFE_VALUES.categoryId
      return next(to)
    }
  }

  next()
}
